const FRONT_REGIONS = [
  { id: "cap", label: "Cap" },
  { id: "gat", label: "Gât" },
  { id: "umeri", label: "Umeri" },
  { id: "piept", label: "Piept" },
  { id: "abdomen", label: "Abdomen" },
  { id: "sold", label: "Șold stâng" },
  { id: "sold_d", label: "Șold drept" },
  { id: "genunchi_s", label: "Genunchi stâng" },
  { id: "genunchi_d", label: "Genunchi drept" },
]

const BACK_REGIONS = [
  { id: "ceafa", label: "Ceafă" },
  { id: "cervical", label: "Cervical" },
  { id: "toracic", label: "Toracic" },
  { id: "lombar", label: "Lombar" },
  { id: "sacru", label: "Sacru" },
  { id: "umar_s", label: "Umăr stâng" },
  { id: "umar_d", label: "Umăr drept" },
  { id: "gluteu", label: "Gluteu" },
  { id: "posterior_coapsa", label: "Coapse" },
]

export function BodyChartPicker({ view, regions, onViewChange, onToggleRegion, pressureNotes, onPressureNotesChange }) {
  const list = view === "back" ? BACK_REGIONS : FRONT_REGIONS
  const selected = new Set(regions || [])

  return (
    <div className="rounded-xl border border-border bg-card p-4 space-y-4">
      <div className="flex flex-wrap gap-2 items-center">
        <span className="text-xs font-medium text-muted-foreground uppercase tracking-wide">Vedere</span>
        <button
          type="button"
          className={`text-xs px-3 py-1 rounded-full border ${view === "front" ? "bg-secondary font-medium" : "border-border"}`}
          onClick={() => onViewChange("front")}
        >
          Față
        </button>
        <button
          type="button"
          className={`text-xs px-3 py-1 rounded-full border ${view === "back" ? "bg-secondary font-medium" : "border-border"}`}
          onClick={() => onViewChange("back")}
        >
          Spate
        </button>
      </div>
      <p className="text-xs text-muted-foreground">
        Selectează zonele țintă pentru osteopatie / masaj terapeutic. Se salvează în planul de îngrijire (body_chart).
      </p>
      <div className="flex flex-wrap gap-2">
        {list.map((r) => (
          <button
            key={r.id}
            type="button"
            onClick={() => onToggleRegion(r.id)}
            className={`text-xs px-2.5 py-1 rounded-md border transition-colors ${
              selected.has(r.id) ? "bg-primary text-primary-foreground border-primary" : "border-border hover:bg-muted"
            }`}
          >
            {r.label}
          </button>
        ))}
      </div>
      {typeof onPressureNotesChange === "function" && (
        <label className="block text-xs space-y-1">
          <span className="text-muted-foreground">Presiune / palpare (notă scurtă)</span>
          <textarea
            className="w-full min-h-[72px] rounded-lg border border-border bg-background px-3 py-2 text-sm"
            value={pressureNotes || ""}
            onChange={(e) => onPressureNotesChange(e.target.value)}
            placeholder="Ex. tensiune supraspinală dreaptă…"
          />
        </label>
      )}
    </div>
  )
}
